import * as React from "react";
import { Box, Card, CardHeader, CardContent, Typography, Stack, ButtonBase } from "@mui/material";
import {
  TextField,
  useTranslate,
  useListContext,
  RaRecord,
  RecordContextProvider,
  ReferenceField,
  useRedirect,
} from "react-admin";

import { StatusLabel } from '../../components/Label/status';
import { formatDateTime } from "../../utils/paymentFormat";
import { projectTypeText } from "./list";

interface MobileGridProps {
  data?: RaRecord[];
}

// A card row: the label in secondary text, the value right-aligned in bold.
const Row = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Box sx={{ typography: "body2", fontWeight: 600, textAlign: "right", "& .MuiTypography-root": { fontWeight: "inherit" } }}>
      {children}
    </Box>
  </Stack>
);

const MobileGrid = (_props: MobileGridProps) => {
    const { data, isLoading } = useListContext();
    const translate = useTranslate();
    const redirect = useRedirect();

    if (isLoading || !data || data.length === 0) {
        return null;
    }

    return (
        <Box margin="0.5em">
            {data.map(record => (
                <RecordContextProvider key={record.id} value={record}>
                    <ButtonBase
                        onClick={() => redirect('show', 'projects', record.id)}
                        sx={{ width: '100%', textAlign: 'left' }}
                    >
                        <Card
                            variant="outlined"
                            sx={{
                                width: '100%',
                                marginBottom: 2,
                                borderRadius: 2,
                                boxShadow: 1,
                                transition: 'box-shadow 0.2s ease-in-out',
                                '&:hover': {
                                    boxShadow: 3,
                                },
                            }}
                        >
                            <CardHeader
                                title={
                                    <Typography variant="h4" fontWeight="bold">
                                        {record.name}
                                    </Typography>
                                }
                                subheader={
                                    <Typography variant="body2" color="text.secondary">
                                        {formatDateTime(record.dateCreated)}
                                    </Typography>
                                }
                            />
                            <CardContent sx={{ pt: 0 }}>
                                <Stack spacing={1}>
                                    <Row label={translate('Status')}>
                                        <StatusLabel statusField="status" />
                                    </Row>
                                    <Row label={translate('Type')}>
                                        {projectTypeText(record.typeProject) || '—'}
                                    </Row>
                                    <Row label={translate('Account')}>
                                        <ReferenceField source="accountId" reference="accounts" link={false}>
                                            <TextField source="name" />
                                        </ReferenceField>
                                    </Row>
                                </Stack>
                            </CardContent>
                        </Card>
                    </ButtonBase>
                </RecordContextProvider>
            ))}
        </Box>
    );
};
MobileGrid.defaultProps = {
  data: {},
  ids: [],
};

export default MobileGrid;
